import React from "react";
import Button from "../button";

interface CustomButtonProps {
  onClick?: (value: any) => void;
  text?: string;
  backgroundColor?: string;
  fontFamily?: string;
  textColor?: string;
  style?: React.CSSProperties;
  after?: React.ReactNode;
  before?: React.ReactNode;
  disabled?: boolean;
  type?: "submit" | "button";
  className?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  onClick,
  text,
  style,
  after,
  before,
  backgroundColor,
  textColor,
  disabled,
  type = "button",
  className,
}) => {
  return (
    <Button
      text={text}
      type={type}
      onClick={onClick}
      disabled={disabled}
      before={before}
      after={after}
      primaryColor={backgroundColor}
      className={className}
      style={{
        color: textColor,
        ...style,
      }}
    />
  );
};

export default CustomButton;
